import React from "react";
import { useContent } from "@/lib/content";
import { useLang } from "@/lib/lang";
import { Quote } from "lucide-react";

/** Horizontal infinite-scroll marquee of client testimonials. */
export default function TestimonialsMarquee() {
  const { testimonials = [], branding = {} } = useContent();
  const { t } = useLang();
  if (!testimonials.length) return null;
  const dup = [...testimonials, ...testimonials];
  const speed = Math.max(20, Number(branding.testimonials_speed_seconds) || 60);

  return (
    <section className="py-16 md:py-24 overflow-hidden border-y border-black/5" style={{ backgroundColor: "#E4DFD3" }} data-testid="testimonials-marquee">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 mb-10">
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">{t.sections?.testimonialsTitle || "Depoimentos"}</div>
        <h2 className="font-display text-3xl md:text-5xl leading-tight max-w-3xl">{t.sections?.testimonialsHeadline || "O que dizem os parceiros que escolheram a Places."}</h2>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track flex gap-6 w-max" style={{ animation: `marquee ${speed}s linear infinite` }}>
          {dup.map((t, i) => (
            <article key={`${t.author}-${i}`} className="shrink-0 w-[400px] md:w-[460px] border border-black/10 bg-white p-6 md:p-8 rounded-md" data-testid={`testimonial-${i % testimonials.length}`}>
              <Quote className="w-7 h-7 text-accent-yellow mb-4" />
              <p className="text-base md:text-lg leading-relaxed text-neutral-800">"{t.text}"</p>
              <div className="mt-5 flex items-center gap-3">
                {t.photo ? (
                  <img src={t.photo} alt={t.author} className="w-11 h-11 rounded-full object-cover" />
                ) : (
                  <div className="w-11 h-11 rounded-full bg-neutral-300 flex items-center justify-center text-xs font-semibold">{t.author?.split(" ").map((s) => s[0]).slice(0, 2).join("")}</div>
                )}
                <div>
                  <div className="font-semibold text-sm">{t.author}</div>
                  <div className="text-xs text-neutral-500">{[t.role, t.company].filter(Boolean).join(" · ")}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
